@if ((incomeTaxEntity$ | async) && isOndernemer) {
    <form [formGroup]="formGroup">
        <div formArrayName="gebruikAuto">
            @for (item of privegebruikAuto.controls; track item; let i = $index) {
                <div [formGroupName]="i" class="row col-auto" style="--bs-gutter-x: 0.5rem;">
                    <snelstart-ui-text-form-control (change)="getCatalogusPrijs(i)"
                                                    [forceInvalidBorder]="!dutchKentekenValidator()"
                                                    [label]="i === 0 ? 'Kenteken' : ''"
                                                    class="custom-input-150"
                                                    formControlName="kenteken"
                                                    id="kenteken"
                    >
                    </snelstart-ui-text-form-control>
                    <div formGroupName="periodePriveGebruik" class="d-flex col-auto" style="--bs-gutter-x: 0.5rem;">

                        <snelstart-ui-date-form-control [label]="i === 0 ? 'Begindatum' : ''"
                                                        class="custom-input-150"
                                                        formControlName="begindatum"
                                                        id="begindatum"
                        >
                        </snelstart-ui-date-form-control>
                        <snelstart-ui-date-form-control [label]="i === 0 ? 'Einddatum' : ''"
                                                        class="custom-input-150 ps-1"
                                                        formControlName="einddatum"
                                                        id="einddatum"
                        >
                        </snelstart-ui-date-form-control>
                    </div>
                    <snelstart-ui-number-form-control [decimals]="0"
                                                      [label]="i === 0 ? 'Cataloguswaarde' : ''"
                                                      align="right"
                                                      class="custom-input-150"
                                                      formControlName="catalogusPrijs"
                                                      id="catalogusPrijs"
                                                      prefix="€"
                    >
                    </snelstart-ui-number-form-control>
                    <snelstart-ui-select-form-control [label]="i === 0 ? '> 500 km p/j priv&eacute; ' : ''"
                                                      [options]="optionsJaNee"
                                                      class="custom-input-150"
                                                      formControlName="autoWordtPriveGebruikt"
                                                      id="autoWordtPriveGebruikt"
                                                      (change)="onAutoWordtPriveGebruiktChange(i)"
                    >
                    </snelstart-ui-select-form-control>

                    <snelstart-ui-select-form-control [options]="optionsJaNeeKms"
                                                      [label]="i === 0 ? 'Km-administratie' : ''"
                                                      [required]="true"
                                                      class="custom-input-150"
                                                      formControlName="kilometerAdministratieAanwezig"
                                                      id="kilometerAdministratieAanwezig"
                                                      [disabledControl]="!!item.controls.autoWordtPriveGebruikt.value "
                    >
                    </snelstart-ui-select-form-control>
                    <snelstart-ui-number-form-control [decimals]="0"
                                                      [label]="i === 0 ? 'Bedrag bijtelling' : ''"
                                                      align="right"
                                                      class="custom-input-150"
                                                      formControlName="priveGebruik"
                                                      prefix="€"
                    >
                    </snelstart-ui-number-form-control>

                    <snelstart-ui-number-form-control [decimals]="0"
                                                      [label]="i === 0 ? 'Af: priv&eacute; betaald' : ''"
                                                      [required]="true"
                                                      align="right"
                                                      class="custom-input-150"
                                                      formControlName="kostenEnLastenVoorEigenRekening"
                                                      id="kostenEnLastenVoorEigenRekeningDisabled"
                                                      prefix="€"
                    >
                    </snelstart-ui-number-form-control>

                    <snelstart-ui-button (click)="verwijderRijAuto(i)"
                                         [class]="i === 0 ? 'firstrowbutton col-auto' : 'col-auto'"
                                         icon="trash"
                                         iconType="light"
                                         id="buttonDeletePrgebrAuto"
                                         size="medium"
                                         type="secondary"
                    >
                    </snelstart-ui-button>
                </div>
            }
            <snelstart-ui-button (click)="addRijAuto()"
                                 class="snelstart-ui-button pb-3"
                                 icon="plus"
                                 type="link">
                Privégebruik auto toevoegen
            </snelstart-ui-button>
        </div>
    </form>

<!--    <snelstart-ui-dialog-definition [(visible)]="dialogVisible" id="dialog" size="lg"-->
<!--                                    title="Specificatie priv&eacute;gebruik auto">-->
<!--        <snelstart-ui-dialog-body>-->
<!--            <form (change)="saveForm()" [formGroup]="formGroup">-->
<!--                <div formArrayName="gebruikAuto">-->
<!--                    @for (item of privegebruikAuto.controls; track item; let i = $index) {-->
<!--                        <div [formGroupName]="i" class="row flex-nowrap" style="&#45;&#45;bs-gutter-x: 0.5rem;">-->
<!--                            @if (i === index) {-->
<!--                                <div formGroupName="periodePriveGebruik">-->
<!--                                    <div class="row">-->
<!--                                        <div class="col-7">-->
<!--                                            <p>Vanaf welke datum in {{ (incomeTaxEntity$ | async)?.year }} staat de auto-->
<!--                                                ter beschikking?</p>-->
<!--                                        </div>-->
<!--                                        <div class="col-2">-->
<!--                                            <snelstart-ui-date-form-control class="custom-input-250"-->
<!--                                                                            formControlName="begindatum"-->
<!--                                                                            id="begindatum"-->
<!--                                                                            label=""-->
<!--                                            >-->
<!--                                            </snelstart-ui-date-form-control>-->
<!--                                        </div>-->
<!--                                        <div class="col-3"></div>-->
<!--                                    </div>-->
<!--                                    <div class="row">-->
<!--                                        <div class="col-7">-->
<!--                                            <p>Tot en met welke datum in {{ (incomeTaxEntity$ | async)?.year }} staat de-->
<!--                                                auto ter beschikking?</p>-->
<!--                                        </div>-->
<!--                                        <div class="col-2">-->
<!--                                            <snelstart-ui-date-form-control class="custom-input-250"-->
<!--                                                                            formControlName="einddatum"-->
<!--                                                                            id="einddatum"-->
<!--                                                                            label=""-->
<!--                                            >-->
<!--                                            </snelstart-ui-date-form-control>-->
<!--                                        </div>-->
<!--                                        <div class="col-3"></div>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                                <div class="row">-->
<!--                                    <div class="col-7">-->
<!--                                        <p>Wordt de auto in {{ (incomeTaxEntity$ | async)?.year }} meer dan 500-->
<!--                                            kilometer per jaar priv&eacute; gebruikt?</p>-->
<!--                                    </div>-->
<!--                                    <div class="col-2">-->
<!--                                        <snelstart-ui-select-form-control [options]="optionsJaNee"-->
<!--                                                                          class="custom-input-250"-->
<!--                                                                          formControlName="autoWordtPriveGebruikt"-->
<!--                                                                          id="autoWordtPriveGebruikt"-->
<!--                                        >-->
<!--                                        </snelstart-ui-select-form-control>-->
<!--                                    </div>-->
<!--                                    <div class="col-3"></div>-->
<!--                                </div>-->
<!--                                @if (item.controls.kenteken.value === null || item.controls.catalogusPrijs.value !== null) {-->
<!--                                    <div class="row">-->
<!--                                        <div class="col-7">-->
<!--                                            <p>Wat is de cataloguswaarde van de auto?</p>-->
<!--                                        </div>-->
<!--                                        <div class="col-2">-->
<!--                                            <snelstart-ui-number-form-control [decimals]="0"-->
<!--                                                                              [disabledControl]="item.controls.kenteken.value !== null"-->
<!--                                                                              align="right"-->
<!--                                                                              class="custom-input-250"-->
<!--                                                                              formControlName="catalogusPrijs"-->
<!--                                                                              id="catalogusPrijs"-->
<!--                                                                              prefix="€"-->
<!--                                            >-->
<!--                                            </snelstart-ui-number-form-control>-->
<!--                                        </div>-->
<!--                                        <div class="col-3"></div>-->
<!--                                    </div>-->
<!--                                }-->
<!--                                <div class="row">-->
<!--                                    <div class="col-7">-->
<!--                                        <p>Hoeveel is er priv&eacute; betaald voor het gebruik?</p>-->
<!--                                    </div>-->
<!--                                    <div class="col-2">-->
<!--                                        <snelstart-ui-number-form-control [decimals]="0"-->
<!--                                                                          [required]="true"-->
<!--                                                                          align="right"-->
<!--                                                                          class="custom-input-250"-->
<!--                                                                          formControlName="kostenEnLastenVoorEigenRekening"-->
<!--                                                                          id="kostenEnLastenVoorEigenRekeningDisabled"-->
<!--                                                                          prefix="€"-->
<!--                                        >-->
<!--                                        </snelstart-ui-number-form-control>-->
<!--                                    </div>-->
<!--                                    <div class="col-3"></div>-->
<!--                                </div>-->
<!--                            }-->
<!--                        </div>-->
<!--                    }-->
<!--                </div>-->
<!--            </form>-->
<!--        </snelstart-ui-dialog-body>-->
<!--        <snelstart-ui-dialog-buttons class="d-flex">-->
<!--            <snelstart-ui-button btn-x class="me-1" id="cancel" type="secondary">Annuleren</snelstart-ui-button>-->
<!--            <snelstart-ui-button (click)="onCalculateRequest()"-->
<!--                                 [disabled]="this.formGroup.controls.gebruikAuto.invalid"-->
<!--                                 icon="check"-->
<!--                                 id="save"-->
<!--                                 ignoreClick-->
<!--                                 type="primary"-->
<!--            >-->
<!--                Berekenen-->
<!--            </snelstart-ui-button>-->
<!--        </snelstart-ui-dialog-buttons>-->
<!--    </snelstart-ui-dialog-definition>-->
}
